/*
 Enhanced multiples-promo Handler
*/

window.MultiplesPromoHandler = (function () {
  let discountActive = false;
  let currentDiscountCode = null;
  let isAutomaticDiscount = false; // Track if auto discount is active
  let hasManualCode = false; // Track if manual code is also active
  let activeItemIds = new Map();
  let debug = false;
  let processingUpdate = false;
  let shopifyManagedMode = false;
  let discountCheckTimer = null;
  let discountCheckAttempts = 0;
  const delayedDiscountCheckDelays = [100, 250, 500, 1000, 1500, 2000, 3000];

  function log(...args) {
    if (debug) {
      console.log('[MultiplesPromoHandler]', ...args);
    }
  }

  function normalizeCode(code) {
    return String(code || '')
      .trim()
      .toUpperCase();
  }

  function getNormalizedActiveCodes() {
    const activeCodes = window.activeMultiBuyCodes?.getActiveCodes?.();
    if (!Array.isArray(activeCodes)) return [];

    return activeCodes.map(normalizeCode).filter(Boolean);
  }

  function extractMultiBuyCodeFromText(text) {
    const normalizedText = normalizeCode(text);
    if (!normalizedText) return '';

    const activeCodes = getNormalizedActiveCodes();
    const configuredCode = activeCodes.find(code => normalizedText.includes(code));
    if (configuredCode) {
      return configuredCode;
    }

    const tokens = normalizedText.split(/[^A-Z0-9]+/).filter(Boolean);
    return tokens.find(token => activeCodes.includes(token)) || '';
  }

  // Enhanced discount code detection including URL discounts
  function getActiveDiscountCode() {
    // Method 1: Manual badge
    const discountTag = document.querySelector('.rebuy-cart__discount-tag');
    if (discountTag && discountTag.offsetParent !== null) {
      log('code obtained thorugh method 1 - manual code input');
      return discountTag.textContent.trim().split(' ')[0].toUpperCase();
    }

    // Method 2: Shopify's cookie (URL discounts only)
    const cookies = document.cookie.split(';');
    const discountCookie = cookies.find(c => c.trim().startsWith('discount_code='));
    if (discountCookie) {
      const code = decodeURIComponent(discountCookie.split('=')[1]).toUpperCase();
      if (code && code !== 'undefined') {
          log('code obtained thorugh method 2 - URL application - cookie detection');
        return code;
      }
    }
    // Method 3: Line item messages (URL OR Auto discounts)
    const lineMessages = document.querySelectorAll('.rebuy-cart__flyout-item-discount-message');
    if (lineMessages.length > 0) {
      // Extract code from message text
      for (const message of lineMessages) {
        const messageText = message.textContent.trim();
        const extractedCode = extractMultiBuyCodeFromText(messageText);
        if (extractedCode) {
        
        // NEW: Distinguish AUTO vs URL
        // If we got here without a cookie, it's an AUTO discount
        const hasCookie = document.cookie.includes('discount_code=');
        
        if (!hasCookie) {
          log('Code obtained through method 3 - AUTO discount (no cookie)', extractedCode);
          return extractedCode;
        } else {
          log('Code obtained through method 3 - URL discount (has cookie)', extractedCode);
          return extractedCode;
        }
      }
    }
    log('Found discount without extractable code');
    return 'UNKNOWN_DISCOUNT';
  }

  return '';
  }

  function isValidMultiBuyCode(code) {
    if (!code) return false;
    const activeCodes = getNormalizedActiveCodes();

    if (!Array.isArray(activeCodes)) return false;

    return activeCodes.includes(normalizeCode(code));
  }

  // Detect automatic Shopify discounts
  function detectAutomaticDiscount(cart) {
    if (!cart || !cart.items) return false;

    // Look for items with discounted_price = 0 (automatic free items)
    const freeItems = cart.items.filter(
      item =>
        item.discounted_price !== undefined &&
        parseInt(item.discounted_price) === 0 &&
        parseInt(item.price) > 0
    );

    if (freeItems.length > 0) {
      const totalItems = cart.items.reduce((sum, item) => {
        return sum + (parseInt(item.price) > 0 ? item.quantity : 0);
      }, 0);
      const freeCount = freeItems.reduce((sum, item) => sum + item.quantity, 0);
      const possibleGroups = Math.floor(totalItems / 3);

      log('Auto discount detection:', {
        freeItems: freeItems.length,
        freeCount,
        totalItems,
        possibleGroups,
      });
      return freeCount > 0 && possibleGroups > 0;
    }
    return false;
  }

  // Get manual discount code if present
  function getManualDiscountCode() {
    let discountCode = '';

    // Method 1: Check visible discount tag
    const discountTag = document.querySelector('.rebuy-cart__discount-tag');
    if (discountTag && discountTag.offsetParent !== null) {
      discountCode = discountTag.textContent.trim().split(' ')[0].toUpperCase();
    }

    // Method 2: Check cart-level discount codes
    if (!discountCode && window.Rebuy?.Cart?.cart?.discount_codes?.length > 0) {
      discountCode = window.Rebuy.Cart.cart.discount_codes[0].code.toUpperCase();
    }

    return discountCode;
  }

  function saveOriginalPriceHTML(itemId) {
    const itemElement = document.querySelector(`[data-item-id="${itemId}"]`);
    if (!itemElement) return false;

    const priceContainer = itemElement.querySelector('.rebuy-cart__flyout-item-price');
    if (!priceContainer) return false;

    if (!priceContainer.hasAttribute('data-original-html')) {
      priceContainer.setAttribute('data-original-html', priceContainer.innerHTML);
      log('Saved original HTML for item:', itemId);
    }
    return true;
  }

  function updateItemPrice(itemData) {
    const { id, freeQty, totalQty, price } = itemData;
    const itemElement = document.querySelector(`[data-item-id="${id}"]`);
    if (!itemElement) return false;

    const priceContainer = itemElement.querySelector('.rebuy-cart__flyout-item-price');
    if (!priceContainer) return false;

    const paidQty = Math.max(0, totalQty - freeQty);
    const paidTotal = (price * paidQty).toFixed(2).replace('.', ',');
    const fullTotal = (price * totalQty).toFixed(2).replace('.', ',');

    const priceHTML =
      freeQty >= totalQty
        ? `<div>
                <span class="rebuy-money sale"><span class="sr-only">${window.themeVariables.strings.discountedPrice}</span><span>0,00€</span></span>
                <span class="rebuy-money compare-at"><span class="sr-only">${window.themeVariables.strings.originalPrice}</span><span>${fullTotal}€</span></span>
               </div>`
        : `<div>
                <span class="rebuy-money sale"><span class="sr-only">${window.themeVariables.strings.discountedPrice}</span><span>${paidTotal}€</span></span>
                <span class="rebuy-money compare-at"><span class="sr-only">${window.themeVariables.strings.originalPrice}</span><span>${fullTotal}€</span></span>
               </div>`;

    priceContainer.innerHTML = priceHTML;
    itemElement.setAttribute('data-multiples-promo-free', freeQty);
    itemElement.setAttribute('data-multiples-promo-total', totalQty);
    log('Updated price display for item:', id);
    return true;
  }

  function addPromoBanner(codeOverride = null) {
    if (document.getElementById('promo-cart-banner')) return true;
    
    const codeToUse = String(codeOverride || currentDiscountCode || '')
      .trim()
      .toUpperCase();
    const config = window.activeMultiBuyCodes.getPromoConfig(codeToUse);
    
    if (!config) { 
      log('No config found for code : ', codeToUse)
      return false;
    } 

  log(`Adding ${config.label} banner to cart`);
  const cartItemsContainer = document.querySelector('[data-rebuy-component="cart-items"]');
  if (!cartItemsContainer) return false;

  const banner = document.createElement('div');
  banner.id = 'promo-cart-banner';
  banner.style.cssText = `
    background-color: #f8f4f4;
    color: palevioletred;
    padding: 5px 15px;
    margin: 0 0 10px 0;
    border-radius: 4px;
    font-weight: bold;
    text-align: center;
    font-size: 14px;
    border-left: 3px solid #ff69b4;
    z-index: 1000;
  `;

  banner.innerHTML = `${config.label} Aktion angewendet!`;
  cartItemsContainer.parentNode.insertBefore(banner, cartItemsContainer);
  log('Promo banner added');
  return true;
  }

  function removePromoBanner() {
    const banner = document.getElementById('promo-cart-banner');
    if (banner) {
      banner.remove();
      log('Promo banner removed');
    }
  }

  function highlightFreeItems(freeItemsData) {
    // Remove existing highlights
    document.querySelectorAll('.multiples-promo-highlight').forEach(el => el.remove());

    freeItemsData.forEach(itemData => {
      const { id } = itemData;
      const itemElement = document.querySelector(`[data-item-id="${id}"]`);
      if (!itemElement) return;

      const variantTitleElement = itemElement.querySelector(
        '.rebuy-cart__flyout-item-variant-title'
      );
      if (!variantTitleElement) return;

      const highlight = document.createElement('span');
      highlight.classList.add('multiples-promo-highlight');
      highlight.style.cssText = `
                background-color: palevioletred;
                color: white;
                padding: 2px 6px;
                border-radius: 3px;
                margin-left: 5px;
                font-size: 11px;
                font-weight: bold;
                display: inline-block;
            `;
      highlight.textContent = 'GRATIS';

      variantTitleElement.appendChild(highlight);
      log('Added highlight to item:', id);
    });
  }

  function removeHighlights() {
    document.querySelectorAll('.multiples-promo-highlight').forEach(el => el.remove());
    log('Removed all highlights');
  }

  // Calculate discounts for both manual and automatic
  function calculateDiscounts(cart) {
    if (!discountActive || !cart || cart.items.length < 3) return [];

    // For automatic discounts, use different logic
    if (isAutomaticDiscount) {
      return calculateAutomaticDiscounts(cart);
    }

    const flatItems = [];
    let totalPricedItems = 0;

    cart.items.forEach(item => {
      if (parseFloat(item.price) > 0) {
        totalPricedItems += item.quantity;
      }
    });

    const config = window.activeMultiBuyCodes.getPromoConfig(currentDiscountCode);
    if (!config) return [];

    const completeGroupCount = Math.floor(totalPricedItems / config.groupSize);
    log('Total items:', totalPricedItems, 'Complete groups:', completeGroupCount);

    if (completeGroupCount === 0) return [];

    cart.items.forEach((item, index) => {
      if (parseFloat(item.price) <= 0) return;
      for (let i = 0; i < item.quantity; i++) {
        flatItems.push({
          id: item.id,
          price: parseInt(item.price, 10),
          originalIndex: index,
          unitIndex: i,
        });
      }
    });

    flatItems.sort((a, b) => {
      if (a.price !== b.price) return a.price - b.price;
      return b.originalIndex - a.originalIndex;
    });

    const itemsForGroups = flatItems.slice(0, completeGroupCount * config.groupSize);
    const groups = [];
    for (let i = 0; i < itemsForGroups.length; i += config.groupSize) {
      groups.push(itemsForGroups.slice(i, i + config.groupSize));
    }

    const freeItems = new Map();
    groups.forEach(group => {
      // Always take the cheapest item in the group (first after sort)
      const freeItem = group[0];
      if (!freeItems.has(freeItem.id)) {
        freeItems.set(freeItem.id, { freeQty: 1 });
      } else {
        const data = freeItems.get(freeItem.id);
        data.freeQty++;
        freeItems.set(freeItem.id, data);
      }
    });

    const result = [];
    for (const [id, data] of freeItems.entries()) {
      const item = cart.items.find(item => item.id === id);
      if (item) {
        const freeQty = Math.min(data.freeQty, item.quantity);
        result.push({
          id: id,
          freeQty: freeQty,
          totalQty: item.quantity,
          price: parseFloat(item.price) / 100,
          title: item.product?.title || 'Item',
        });
      }
    }

    return result;
  }

  // Calculate discounts for automatic Shopify discounts
  function calculateAutomaticDiscounts(cart) {
    const result = [];
    cart.items.forEach(item => {
      if (
        item.discounted_price !== undefined &&
        parseInt(item.discounted_price) === 0 &&
        parseInt(item.price) > 0
      ) {
        result.push({
          id: item.id,
          freeQty: item.quantity,
          totalQty: item.quantity,
          price: parseFloat(item.price) / 100,
          title: item.product?.title || 'Item',
        });
        log('Found automatic free item:', item.id, 'quantity:', item.quantity);
      }
    });
    return result;
  }

  function resetItemPrice(itemId) {
    const itemElement = document.querySelector(`[data-item-id="${itemId}"]`);
    if (!itemElement) return false;

    itemElement.removeAttribute('data-multiples-promo-free');
    itemElement.removeAttribute('data-multiples-promo-total');

    const priceContainer = itemElement.querySelector('.rebuy-cart__flyout-item-price');
    if (priceContainer && priceContainer.hasAttribute('data-original-html')) {
      priceContainer.innerHTML = priceContainer.getAttribute('data-original-html');
      priceContainer.removeAttribute('data-original-html');
      log('Restored original price for item:', itemId);
      return true;
    }
    return false;
  }

  function applyFreeItemUI(freeItemsData) {
    if (shopifyManagedMode) return; 
    if (!discountActive) return;

    resetUI();
    if (freeItemsData.length === 0) return;

    // Save original prices and add to tracking
    freeItemsData.forEach(itemData => {
      saveOriginalPriceHTML(itemData.id);
      activeItemIds.set(itemData.id, itemData);
    });

    // Apply price updates
    freeItemsData.forEach(itemData => {
      updateItemPrice(itemData);
    });

    addPromoBanner();
    highlightFreeItems(freeItemsData);
    log('Applied UI updates to', freeItemsData.length, 'items');
  }

  function resetUI() {
    log('Resetting UI');
    activeItemIds.forEach((_, id) => resetItemPrice(id));
    document.querySelectorAll('[data-multiples-promo-free]').forEach(el => {
      const itemId = el.getAttribute('data-item-id');
      if (itemId) resetItemPrice(itemId);
    });

    removePromoBanner();
    removeHighlights();
    activeItemIds.clear();
  }

  function reapplyUIAfterRebuyRender() {
    if (!discountActive || activeItemIds.size === 0 || shopifyManagedMode) return;

    log('Re-applying UI update after Rebuy render');
    activeItemIds.forEach((itemData, id) => {
      updateItemPrice(itemData);
    });

    addPromoBanner();
    highlightFreeItems(Array.from(activeItemIds.values()));
  }

  function processCart(cart) {
    if (shopifyManagedMode) {
      log('Shopify-managed mode: skipping custom price UI');
      return;
    }
    if (processingUpdate) {
      log('Already processing an update, skipping');
      return;
    }

    processingUpdate = true;
    try {
      log('Processing cart with discount active:', discountActive);
      if (!discountActive || !cart) {
        resetUI();
        return;
      }

      const freeItemsData = calculateDiscounts(cart);
      if (freeItemsData.length > 0) {
        applyFreeItemUI(freeItemsData);
      } else {
        resetUI();
      }
    } catch (error) {
      log('Error processing cart:', error);
    } finally {
      processingUpdate = false;
    }
  }

  function deactivateHandler() {
    log('Deactivating Multiples');
    discountCheckAttempts = 0;
    if (discountCheckTimer) {
      clearTimeout(discountCheckTimer);
      discountCheckTimer = null;
    }

    discountActive = false;
    currentDiscountCode = null;
    isAutomaticDiscount = false;
    hasManualCode = false;
    processingUpdate = false;

    // Cleanup
    document.querySelectorAll('[data-multiples-promo-free]').forEach(el => {
      el.removeAttribute('data-multiples-promo-free');
      el.removeAttribute('data-multiples-promo-total');
    });

    document.querySelectorAll('[data-item-id]').forEach(el => {
      const priceContainer = el.querySelector('.rebuy-cart__flyout-item-price');
      if (priceContainer && priceContainer.hasAttribute('data-original-html')) {
        priceContainer.innerHTML = priceContainer.getAttribute('data-original-html');
        priceContainer.removeAttribute('data-original-html');
      }
    });

    removePromoBanner();
    removeHighlights();
    activeItemIds.clear();
  }

  function requestDiscountCheck(delay = 0, resetAttempts = false) {
    if (resetAttempts) {
      discountCheckAttempts = 0;
      if (discountCheckTimer) {
        clearTimeout(discountCheckTimer);
        discountCheckTimer = null;
      }
    }

    if (discountCheckTimer) return;

    discountCheckTimer = setTimeout(() => {
      discountCheckTimer = null;
      checkDiscountCode();
    }, delay);
  }

  function retryUntilShopifyManagedUIIsReady(cart, multiplesCode, bannerAdded) {
    const cartHasItems = Array.isArray(cart?.items) && cart.items.length > 0;
    const hasRenderedItems = document.querySelectorAll('[data-rebuy-component="cart-items"] [data-item-id]').length > 0;
    const hasDiscountMessages = document.querySelectorAll(
      '.rebuy-cart__flyout-item-discount-message'
    ).length > 0;
    const needsRetry =
      Boolean(multiplesCode) && (!bannerAdded || (cartHasItems && (!hasRenderedItems || !hasDiscountMessages)));

    if (!needsRetry) {
      discountCheckAttempts = 0;
      return;
    }

    const delay = delayedDiscountCheckDelays[discountCheckAttempts];
    if (typeof delay === 'undefined') {
      log('Shopify-managed promo UI did not settle before retry limit');
      return;
    }

    discountCheckAttempts += 1;
    log('Retrying Shopify-managed promo UI after delayed Rebuy render', {
      attempt: discountCheckAttempts,
      delay,
      bannerAdded,
      cartHasItems,
      hasRenderedItems,
      hasDiscountMessages,
    });
    requestDiscountCheck(delay);
  }

  function checkDiscountCode() {
  log('Checking for discount codes and automatic discounts');

  if (window.RebuyUtils?.fetchCart) {
    window.RebuyUtils.fetchCart().then(cart => {
      const activeCode = getActiveDiscountCode();
      const hasValidManualCode = activeCode && isValidMultiBuyCode(activeCode);
      const hasDiscountCookie = document.cookie.includes('discount_code=');

      // Always check for AUTO discount
      const hasAutoDiscount = detectAutomaticDiscount(cart);

      const isShopifyManaged = (hasDiscountCookie && hasValidManualCode) || hasAutoDiscount;

      log('Discount check results:', {
        hasAutoDiscount,
        activeCode,
        hasValidManualCode,
        hasDiscountCookie,
        isShopifyManaged,
      });

      // Determine what to activate
      if (isShopifyManaged || hasValidManualCode) {
        const wasShopifyManaged = shopifyManagedMode;
        const hadManualCode = hasManualCode;
        log('Determine what to activate ->', isShopifyManaged, hadManualCode);

        // Keep automatic vs manual semantics clean
        shopifyManagedMode = isShopifyManaged; // URL or Auto → true
        isAutomaticDiscount = hasAutoDiscount; // Auto only (not URL)
        hasManualCode = hasValidManualCode && !isShopifyManaged;

        discountActive = shopifyManagedMode || hasManualCode;
        currentDiscountCode = hasValidManualCode ? activeCode : 'SHOPIFY_MANAGED';

          if (shopifyManagedMode) {
            log('[DEBUG] Entering Shopify managed mode');
            resetUI();
            log('[DEBUG] resetUI complete, banner should be removed');

            log('Shopify-managed discount (URL or Auto) - promotional UI only');
            
            // Find multiples code from line messages for banner
            let multiplesCode = null;
            
            if (isAutomaticDiscount) {
              log('[DEBUG] AUTO is active, looking for multiples code');
              const lineMessages = document.querySelectorAll('.rebuy-cart__flyout-item-discount-message');
              log('[DEBUG] Found', lineMessages.length, 'line messages');
              
              for (const message of lineMessages) {
                const messageText = message.textContent.trim();
                const codePart = extractMultiBuyCodeFromText(messageText);
                log('[DEBUG] Checking line message text:', messageText, 'resolved code:', codePart);
                
                if (isValidMultiBuyCode(codePart)) {
                  multiplesCode = codePart;
                  log('[DEBUG] Found AUTO multiples code for banner:', codePart);
                  break;
                } else {
                  log('[DEBUG] Code not in multiples config, skipping:', codePart);
                }
              }
            } else if (hasValidManualCode) {
              log('[DEBUG] URL multiples scenario, using activeCode:', activeCode);
              multiplesCode = activeCode;
            } else {
              log('[DEBUG] Not AUTO and not valid manual code');
            }
            
            // Add banner with correct code
            if (multiplesCode) {
              log('[DEBUG] Attempting to add banner with code:', multiplesCode);
              const bannerAdded = addPromoBanner(multiplesCode);
              log('[DEBUG] Banner added via config');
              highlightShopifyManagedItems(cart);
              retryUntilShopifyManagedUIIsReady(cart, multiplesCode, bannerAdded);
            } else {
              log('[DEBUG] No multiples code found for banner');
            }

            return; // **HARD EXIT** → do not call processCart()
          }

        // Manual Discount Only: Full custom processing (our preview)
        if (!wasShopifyManaged || hadManualCode !== hasManualCode) {
          log('Manual discount detected - processing cart with full custom logic');
          processCart(cart);
        }
      } else if (discountActive) {
        log('No valid discounts found, deactivating');
        deactivateHandler();
      }
    });
  }
  }

  function highlightShopifyManagedItems(cart) {
  // Remove existing highlights first
  document.querySelectorAll('.multiples-promo-highlight').forEach(el => el.remove());

  // Find items with green discount messages (Shopify-managed)
  const shopifyDiscountedItems = document.querySelectorAll(
    '.rebuy-cart__flyout-item-discount-message'
  );

  shopifyDiscountedItems.forEach(messageEl => {
    const itemElement = messageEl.closest('.rebuy-cart__flyout-item');
    if (!itemElement) return;

    // Extract code from message
    const messageText = messageEl.textContent.trim();
    const codePart = extractMultiBuyCodeFromText(messageText);
    
    // Check if this is a valid multiples code (manual/URL/AUTO)
    if (!isValidMultiBuyCode(codePart)) {
      log('Skipping GRATIS for non-multiples discount:', codePart);
      return;
    }

    // This is a multiples discount - add GRATIS
    const variantTitleElement = itemElement.querySelector(
      '.rebuy-cart__flyout-item-variant-title'
    );
    if (!variantTitleElement) return;

    const highlight = document.createElement('span');
    highlight.classList.add('multiples-promo-highlight');
    highlight.style.cssText = `
      background-color: palevioletred;
      color: white;
      padding: 2px 6px;
      border-radius: 3px;
      margin-left: 5px;
      font-size: 11px;
      font-weight: bold;
      display: inline-block;
    `;
    highlight.textContent = 'GRATIS';

    variantTitleElement.appendChild(highlight);
    log('Added highlight to Shopify-managed item:', itemElement.getAttribute('data-item-id'));
  });
  }

  // Public API
  return {
    init: function () {
      log('Initializing');
      if (!window.RebuyEventManager || !window.RebuyUtils?.fetchCart) return this;

      this.isValidMultiBuyCode = isValidMultiBuyCode;

      window.RebuyEventManager.on('cart:ready', () => requestDiscountCheck(50, true))
        .on('cart:show', data => {
          requestDiscountCheck(50, true);
          if (discountActive) {
            setTimeout(reapplyUIAfterRebuyRender, 200);
          }
        })
        .on('cart:change', data => {
          log('cart:change event received');
          requestDiscountCheck(50, true);
          if (discountActive) {
            setTimeout(() => processCart(data.cart), 100);
            setTimeout(reapplyUIAfterRebuyRender, 300);
          }
        })
        .on('discount:applied', data => {
          log('discount:applied event received');
          requestDiscountCheck(50, true);
        })
        .on('discount:removed', () => {
          log('discount:removed event received');
          deactivateHandler();
        });

      window.addEventListener('pageshow', () => requestDiscountCheck(100, true));
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          requestDiscountCheck(100, true);
        }
      });

      requestDiscountCheck(500, true);
      return this;
    },

    checkDiscount: function () {
      checkDiscountCode();
      return this;
    },

    deactivate: function () {
      deactivateHandler();
      return this;
    },

    processCart: function (cart) {
      if (!cart && window.RebuyUtils?.fetchCart) {
        window.RebuyUtils.fetchCart().then(processCart);
      } else {
        processCart(cart);
      }
      return this;
    },

    refresh: function () {
      if (discountActive) {
        resetUI();
        window.RebuyUtils.fetchCart().then(processCart);
      }
      return this;
    },

    debug: function (enabled) {
      debug = enabled;
      log('Debug logging', enabled ? 'enabled' : 'disabled');
      return this;
    },

    // Helper methods for debugging
    getState: function () {
      const activeConfig = currentDiscountCode 
        ? window.activeMultiBuyCodes.getPromoConfig(currentDiscountCode)
        : null;
      
      return {
        discountActive,
        currentDiscountCode,
        isAutomaticDiscount,
        hasManualCode,
        activeItemIds: Array.from(activeItemIds.values()),
        // these are only really relating to manual code input
        promoConfig: activeConfig,
        enabledPromos: {
          threeFor2: window.activeMultiBuyCodes.enable3for2,
          fourFor3: window.activeMultiBuyCodes.enable4for3,
        }
      };
    },
  };
})();
